"use client";
import { useLocale } from "next-intl";
import formatDate from "../../common/utils/formatDate";
import DOMRenderer from "../../cms/components/DOMRenderer";

export const MaintenanceItem = ({ from, to, text }) => {
  const locale = useLocale();
  const fromDate = new Date(from);
  const toDate = new Date(to);

  let dateString = "n/a";
  if (fromDate.getDate() === toDate.getDate()) {
    dateString = `${formatDate(from, locale, {
      dateStyle: "short",
    })}, ${formatDate(from, locale, {
      timeStyle: "short",
    })} - ${formatDate(to, locale, { timeStyle: "short" })}`;
  } else {
    dateString = `${formatDate(from, locale, {
      dateStyle: "short",
      timeStyle: "short",
    })} - ${formatDate(to, locale, {
      dateStyle: "short",
      timeStyle: "short",
    })}`;
  }

  return (
    <p className="mb-5">
      <b className="d-block mb-2">{dateString}</b>
      <DOMRenderer htmlString={text} />
    </p>
  );
};

export default MaintenanceItem;
